import axiosClient from "./axiosClient";

export const MasterRoleApi = {
  getMasterRole: () => {
    const url = `/api/master/users/get`;
    return axiosClient.post(url);
  },
};
